// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__xBGxP","tab-processing":"Tab_tab-processing__WVwUv","tab-info":"Tab_tab-info__AW26y"};